import React from 'react';

import styled, { createGlobalStyle } from 'styled-components';
import { BACKGROUND } from '../../../theme';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${BACKGROUND};
    height: calc(100vh - 112px) !important;

    // override global styles
    & html, body {
      height: calc(100vh - 112px) !important;
    }
  }
`;

const Inner = styled.div`
  width: 1120px;
  margin: 52px auto 0;
  padding-bottom: 120px;
`;

const Container: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <>
    <GlobalStyle />
    <Inner>{children}</Inner>
  </>
);

export default Container;
